"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZonedDate = void 0;
const moment_timezone_1 = __importStar(require("moment-timezone"));
const timezone_1 = require("./timezone");
/**
 * This is a (mostly) drop-in replacement for Date that keeps the date/time locked to a specified default Time Zone.
 * It overrides the methods in Date and bases them on timezone-aware moment instead.
 */
class ZonedDate extends Date {
    static setDefault(timezone) {
        ZonedDate.timezone = timezone;
    }
    static fromSelectedDate(selectedDate) {
        if (selectedDate !== undefined && selectedDate !== null) {
            const resultDate = new ZonedDate();
            resultDate.setFullYear(selectedDate.getFullYear());
            resultDate.setMonth(selectedDate.getMonth());
            resultDate.setDate(selectedDate.getDate());
            resultDate.setHours(selectedDate.getHours());
            resultDate.setMinutes(selectedDate.getMinutes());
            resultDate.setSeconds(selectedDate.getSeconds());
            resultDate.setMilliseconds(selectedDate.getMilliseconds());
            return resultDate;
        }
        return null;
    }
    constructor(firstArg, ...otherArgs) {
        let thisMoment;
        if (firstArg === undefined) {
            thisMoment = moment_timezone_1.default.tz(ZonedDate.timezone);
        }
        else if (otherArgs.length === 0) {
            if (typeof firstArg === "string" || typeof firstArg === "number") {
                thisMoment = moment_timezone_1.default.tz(firstArg, ZonedDate.timezone);
            }
            else if (firstArg instanceof ZonedDate) {
                thisMoment = moment_timezone_1.default.tz(firstArg.moment, ZonedDate.timezone);
            }
            else if (firstArg instanceof Date || (0, moment_timezone_1.isMoment)(firstArg)) {
                thisMoment = moment_timezone_1.default.tz(firstArg, ZonedDate.timezone);
            }
            else {
                throw new Error(`Invalid argument: ${firstArg}`);
            }
        }
        else {
            thisMoment = moment_timezone_1.default.tz({
                year: firstArg,
                month: otherArgs[0],
                date: otherArgs.length > 1 ? otherArgs[1] : 0,
                hour: otherArgs.length > 2 ? otherArgs[2] : 0,
                minute: otherArgs.length > 3 ? otherArgs[3] : 0,
                second: otherArgs.length > 4 ? otherArgs[4] : 0,
                ms: otherArgs.length > 5 ? otherArgs[5] : 0,
            }, ZonedDate.timezone);
        }
        if (!thisMoment.isValid()) {
            throw new Error(`Invalid date: ${thisMoment}`);
        }
        super(thisMoment.valueOf());
        this.moment = thisMoment;
    }
    getTimezoneOffset() {
        return -this.moment.utcOffset();
    }
    valueOf() {
        return this.moment.valueOf();
    }
    getTime() {
        return this.moment.valueOf();
    }
    setTime(time) {
        const offset = this.moment.utcOffset();
        this.moment.utcOffset(offset);
        this.moment = (0, moment_timezone_1.default)(time);
        super.setTime(this.moment.valueOf());
        return this.moment.valueOf();
    }
    // local get + set
    _setLocal({ YY, MM, DD, hh, mm, ss, ms, }) {
        if (YY !== undefined)
            this.moment.year(YY);
        if (MM !== undefined)
            this.moment.month(MM);
        if (DD !== undefined)
            this.moment.date(DD);
        if (hh !== undefined)
            this.moment.hour(hh);
        if (mm !== undefined)
            this.moment.minute(mm);
        if (ss !== undefined)
            this.moment.second(ss);
        if (ms !== undefined)
            this.moment.millisecond(ms);
        return this.setTime(this.moment.utc().valueOf());
    }
    getFullYear() {
        return this.moment.year();
    }
    setFullYear(YY, MM, DD) {
        return this._setLocal({ YY, MM, DD });
    }
    getYear() {
        return this.moment.year() - 1900;
    }
    setYear(YY) {
        return this._setLocal({ YY: YY < 100 ? 1900 + YY : YY });
    }
    getMonth() {
        return this.moment.month();
    }
    setMonth(MM, DD) {
        return this._setLocal({ MM, DD });
    }
    getDate() {
        return this.moment.date();
    }
    setDate(DD) {
        return this._setLocal({ DD });
    }
    getHours() {
        return this.moment.hour();
    }
    setHours(hh, mm, ss, ms) {
        return this._setLocal({ hh, mm, ss, ms });
    }
    getMinutes() {
        return this.moment.minute();
    }
    setMinutes(mm, ss, ms) {
        return this._setLocal({ mm, ss, ms });
    }
    getSeconds() {
        return this.moment.second();
    }
    setSeconds(ss, ms) {
        return this._setLocal({ ss, ms });
    }
    getMilliseconds() {
        return this.moment.millisecond();
    }
    setMilliseconds(ms) {
        return this._setLocal({ ms });
    }
    getDay() {
        return this.moment.day();
    }
    // UTC get + set
    _setUTC({ YY, MM, DD, hh, mm, ss, ms, }) {
        const utc = (0, moment_timezone_1.default)(this.moment).utc();
        if (YY !== undefined)
            utc.year(YY);
        if (MM !== undefined)
            utc.month(MM);
        if (DD !== undefined)
            utc.date(DD);
        if (hh !== undefined)
            utc.hour(hh);
        if (mm !== undefined)
            utc.minute(mm);
        if (ss !== undefined)
            utc.second(ss);
        if (ms !== undefined)
            utc.millisecond(ms);
        return this.setTime(utc.valueOf());
    }
    getUTCFullYear() {
        return this.moment.utc().year();
    }
    setUTCFullYear(YY, MM, DD) {
        return this._setUTC({ YY, MM, DD });
    }
    getUTCMonth() {
        return this.moment.utc().month();
    }
    setUTCMonth(MM, DD) {
        return this._setUTC({ MM, DD });
    }
    getUTCDate() {
        return this.moment.utc().date();
    }
    setUTCDate(DD) {
        return this._setUTC({ DD });
    }
    getUTCHours() {
        return this.moment.utc().hour();
    }
    setUTCHours(hh, mm, ss, ms) {
        return this._setUTC({ hh, mm, ss, ms });
    }
    getUTCMinutes() {
        return this.moment.utc().minute();
    }
    setUTCMinutes(mm, ss, ms) {
        return this._setUTC({ mm, ss, ms });
    }
    getUTCSeconds() {
        return this.moment.utc().second();
    }
    setUTCSeconds(ss, ms) {
        return this._setUTC({ ss, ms });
    }
    getUTCMilliseconds() {
        return this.moment.utc().millisecond();
    }
    setUTCMilliseconds(ms) {
        return this._setUTC({ ms });
    }
    getUTCDay() {
        return this.moment.utc().day();
    }
    // string methods
    toLocaleString(locales, options) {
        return Intl.DateTimeFormat(locales, Object.assign({ timeZone: ZonedDate.timezone, dateStyle: "short", timeStyle: "medium" }, options)).format(this.moment.toDate());
    }
    toLocaleDateString(locales, options) {
        return Intl.DateTimeFormat(locales, Object.assign(Object.assign({}, options), { timeZone: ZonedDate.timezone, dateStyle: "short", timeStyle: undefined })).format(this.moment.toDate());
    }
    toLocaleTimeString(locales, options) {
        return Intl.DateTimeFormat(locales, Object.assign(Object.assign({}, options), { timeZone: ZonedDate.timezone, dateStyle: undefined, timeStyle: "medium" })).format(this.moment.toDate());
    }
    toTimeString() {
        const tzName = (0, timezone_1.getTimeZoneName)(this.moment);
        return this.moment.format("HH:mm:ss [GMT]ZZ") + ` (${tzName})`;
    }
    toDateString() {
        return this.moment.format("ddd MMM DD YYYY");
    }
    toUTCString() {
        return (0, moment_timezone_1.default)(this.moment).utc().format("ddd, DD MMM YYYY HH:mm:ss [GMT]");
    }
    toISOString() {
        return this.moment.toISOString();
    }
    toJSON() {
        return this.moment.toDate().toJSON();
    }
    toString() {
        return this.moment.toString();
    }
    // convert to a standard Date
    toDate() {
        return this.moment.toDate();
    }
    // return a copy of the date forced into the local timezone (hours/mins/secs not adjusted)
    // this can be handy when workng with date pickers that work on standard Dates, it is the inverse of fromSelectedDate
    toSelectDate() {
        const resultDate = new Date();
        resultDate.setFullYear(this.getFullYear());
        resultDate.setMonth(this.getMonth());
        resultDate.setDate(this.getDate());
        resultDate.setHours(this.getHours());
        resultDate.setMinutes(this.getMinutes());
        resultDate.setSeconds(this.getSeconds());
        resultDate.setMilliseconds(this.getMilliseconds());
        return resultDate;
    }
}
exports.ZonedDate = ZonedDate;
